<template lang="html">
	<core-page class="omapi-omu">
		<common-alerts id="omu-errors" :alerts="alerts"/>
		<common-card
			v-if="isLiteUser"
			class="omapi-omu__upgrade"
		>
			<h2>OM University is available only for OptinMonster Pro users.</h2>
			<p><mark>As a loyal OptinMonster Lite user, If you choose to upgrade to Pro, you will receive a</mark><br><mark><strong>35% discount</strong> - automatically applied on cart.</mark></p>
			<core-upgrade-button
				color="green"
				size="xlarge"
				utmMedium="OMU"
				:features="['omu']"
			>
				Upgrade to Pro and Unlock OM University
			</core-upgrade-button>
		</common-card>
		<common-card>
			<university-courses/>
			<hr/>
			<university-guides/>
		</common-card>
	</core-page>
</template>

<script lang="js">
import { mapActions, mapState, mapGetters } from 'vuex'

export default  {
	mounted () {
		this.fetchGuides()
		this.fetchCourses()
	},
	computed : {
		...mapGetters([ 'isLiteUser' ]),
		...mapState([ 'alerts' ]),
	},
	methods : {
		...mapActions('omu', [ 'fetchGuides', 'fetchCourses' ]),
	},
}
</script>

<style lang="scss">
	@import '../assets/scss/variables';
	@import '../assets/scss/pages/omu';
</style>
